import { RadioButtonGroup } from "@repo/skapa";
import { t } from "@repo/translation";
import { ModalSheet, SectionContainer } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";
import { useState } from "react";

interface PlannerListItem {
  name: string;
  applicationId?: string;
  designUrlNew?: string;
}

interface AddDrawingModalProps {
  isOpen: boolean;
  closeModal: () => void;
  plannerList: PlannerListItem[];
}

export const CreateDrawingModal = ({
  isOpen,
  closeModal,
  plannerList,
}: AddDrawingModalProps) => {
  const [selectedPlanner, setSelectedPlanner] =
    useState<PlannerListItem | null>(null);
  const reset = () => {
    setSelectedPlanner(null);
  };

  const handleCreateDrawing = () => {
    if (!selectedPlanner?.designUrlNew) {
      return;
    }

    window.open(selectedPlanner.designUrlNew, "_blank");

    trackAnalytics("create_planner_drawing");

    reset();
    closeModal();
  };

  return (
    <ModalSheet
      title={t("action.create_planner_drawing")}
      visible={isOpen}
      onClose={() => {
        reset();
        closeModal();
      }}
      primaryButtonProps={{
        text: t("action.create_planner_drawing"),
        disabled: !selectedPlanner,
        onClick: handleCreateDrawing,
      }}
    >
      <SectionContainer>
        <RadioButtonGroup
          subtle
          name={t("label.select_planner_type")}
          list={[...plannerList]
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((planner) => ({
              name: "plannerType",
              key: `plannerType-${planner.applicationId ?? planner.name}`,
              id: `plannerType-${planner.applicationId ?? planner.name}`,
              label: planner.name,
              value: planner.name,
              checked: selectedPlanner?.name === planner.name,
              onChange: () => setSelectedPlanner(planner),
            }))}
        />
      </SectionContainer>
    </ModalSheet>
  );
};
